import { Components } from '@mui/material'

export function OverridedLink(): Components {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'none',
      },
      styleOverrides: {
        root: {
          cursor: 'pointer',
          fontWeight: 500,
        },
      },
    },
  }
}
